import * as React from 'react';

import cn from 'classnames';

import { breakpoints, IBasicStyledProps } from '@notino/react-styleguide';

import {
  desktopVisibleLg,
  desktopVisibleMd,
  desktopVisibleSm,
  desktopVisibleXl,
  desktopVisibleXxl,
  mobileVisibleLg,
  mobileVisibleMd,
  mobileVisibleSm,
  mobileVisibleXl,
  mobileVisibleXxl,
} from '@styles/common';

type Props = {
  children?: React.ReactNode;
  breakpoint: keyof typeof breakpoints;
} & IBasicStyledProps;

export const Hidden = ({ children, breakpoint, className, ...rest }: Props) => {
  const map: Record<keyof typeof breakpoints, string> = {
    xs: '',
    sm: mobileVisibleSm,
    md: mobileVisibleMd,
    lg: mobileVisibleLg,
    xl: mobileVisibleXl,
    xxl: mobileVisibleXxl,
    xxxl: '',
  };
  return (
    <div className={cn(map[breakpoint], className)} {...rest}>
      {children}
    </div>
  );
};

export const Visible = ({
  children,
  breakpoint,
  className,
  ...rest
}: Props) => {
  const map: Record<keyof typeof breakpoints, string> = {
    xs: '',
    sm: desktopVisibleSm,
    md: desktopVisibleMd,
    lg: desktopVisibleLg,
    xl: desktopVisibleXl,
    xxl: desktopVisibleXxl,
    xxxl: '',
  };
  return (
    <div className={cn(map[breakpoint], className)} {...rest}>
      {children}
    </div>
  );
};
